import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const SOCIAL = [
  ["Instagram", "https://www.instagram.com/joetanisphotography/"],
  ["Facebook", "https://www.facebook.com/JoeTanisPhotography/"],
  ["LinkedIn", "https://www.linkedin.com/in/joe-tanis-5a0b6918/"],
  ["Email me", "mailto:joe@joetanis.com"],
];

export const SiteMenu = ({ items }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const list = Array.isArray(items) ? items : [];

  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <header className={`jt-menu ${open ? "is-open" : ""}`} ref={ref} data-testid="site-menu">
      <button
        type="button"
        className="jt-menu-btn"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-label={open ? "Close menu" : "Open menu"}
        data-testid="menu-toggle-button"
      >
        <span className="jt-menu-btn__track">
          <span className="jt-menu-btn__face jt-menu-btn__face--menu">MENU</span>
          <span className="jt-menu-btn__face jt-menu-btn__face--close">CLOSE</span>
        </span>
      </button>
      <nav className="jt-menu-panel" aria-label="Portfolio" aria-hidden={!open}>
        <div className="jt-menu-inner">
          <ul className="jt-menu-grid" style={{ listStyle: "none", margin: 0, padding: 0 }}>
            {list.map((m) => (
              <li className="jt-menu-item" key={m.slug}>
                <Link
                  to={`/${m.slug}`}
                  className="jt-menu-link"
                  onClick={() => setOpen(false)}
                  tabIndex={open ? 0 : -1}
                  data-testid={`menu-link-${m.slug}`}
                >
                  <span className="jt-menu-arrow" aria-hidden="true"><i /></span>
                  <span className="jt-menu-text">{m.label}</span>
                </Link>
              </li>
            ))}
          </ul>
          <ul className="jt-menu-social">
            {SOCIAL.map(([label, href]) => (
              <li key={label}>
                <a href={href} target="_blank" rel="noopener noreferrer" tabIndex={open ? 0 : -1} data-testid={`menu-social-${label.toLowerCase().replace(/\s/g, "-")}`}>
                  {label}
                </a>
              </li>
            ))}
          </ul>
          <div className="jt-menu-credit">
            <a href="https://webbalu.com" target="_blank" rel="noopener noreferrer" tabIndex={open ? 0 : -1}>
              Site Design + Development by Webbalu.
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
};
